import { atom, selectorFamily } from 'recoil';
import { CustomerInvoicesUnpaidService } from 'api';
export const getUnpaidInvoicesRequestIdState = atom({
  key: 'getUnpaidInvoicesRequestIdState',
  default: 0
});
export const getUnpaidInvoicesForCustomer = selectorFamily({
  key: 'getUnpaidInvoicesForCustomer',
  get: customerId => async ({
    get
  }) => {
    get(getUnpaidInvoicesRequestIdState);
    if (!customerId) return {};
    try {
      return await CustomerInvoicesUnpaidService.getUnpaidInvoicesByCustomerId({
        customerId,
        body: {}
      });
    } catch (e) {
      console.error(e);
    }
    return {};
  }
});